import { ISelectData } from 'components/atoms/SelectComponent';

import { EHlasovani } from 'enums/akcionarKorpAkce/hlasovani';

export const hlasovaniData: ISelectData[] = [
    {
        labelcz: 'ABST',
        value: EHlasovani.ABST
    },
    {
        labelcz: 'CAGS',
        value: EHlasovani.CAGS
    },
    {
        labelcz: 'AMGT',
        value: EHlasovani.AMGT
    },
    {
        labelcz: 'BLNK',
        value: EHlasovani.BLNK
    },
    {
        labelcz: 'CHRM',
        value: EHlasovani.CHRM
    },
    {
        labelcz: 'DISC',
        value: EHlasovani.DISC
    },
    {
        labelcz: 'CFOR',
        value: EHlasovani.CFOR
    },
    {
        labelcz: 'NOAC',
        value: EHlasovani.NOAC
    },
    {
        labelcz: 'ONEY',
        value: EHlasovani.ONEY
    },
    {
        labelcz: 'THRY',
        value: EHlasovani.THRY
    },
    {
        labelcz: 'TWOY',
        value: EHlasovani.TWOY
    },
    {
        labelcz: 'WTHH',
        value: EHlasovani.WTHH
    },
    {
        labelcz: 'WMGT',
        value: EHlasovani.WMGT
    }
];
